module.exports = __webpack_public_path__ + "images/mobile/icon-wxwork-257feffee1b548333d452777c78a1229.png";